import { getAllByPlaceholderText } from '@testing-library/react';
import { useEffect, useState } from 'react';

import { Container, Title, Hashtag, AreaHash } from './styles';

interface HProps {
  remove: (e: any) => void;
  currentHashtags?: string;
  data: any[];
  tipo: string;
}

export default function ListHashStateless({
  currentHashtags,
  data,
  remove,
  tipo,
}: HProps) {
  const [hashtags, setHashtags] = useState<any>();
  const [hover, setHover] = useState<boolean>(false);
  const [labelHover, setLabelHover] = useState<string>('');

  // useEffect(() => {
  //   console.log('data', data);
  // }, [data]);

  return (
    <Container>
      <AreaHash>
        {data?.map((response: any, key) => (
          <Hashtag
            onClick={() => {
              remove(response);
            }}
            key={key}
            className="animate__animated animate__fadeIn"
            onMouseOver={() => {
              setHover(true);
              setLabelHover(response);
            }}
            onMouseOut={() => {
              setHover(false);
              setLabelHover('');
            }}
          >
            {tipo === 'object' && response.label}
            {tipo === 'object-edit' && response.titulo}
            {tipo === 'string' && response}
          </Hashtag>
        ))}
      </AreaHash>
    </Container>
  );
}
